import { render } from "./ProjectsList.vue?vue&type=template&id=76fd69f8"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/components/Projects/ProjectsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76fd69f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76fd69f8', __exports__)) {
    api.reload('76fd69f8', __exports__)
  }
  
  module.hot.accept("./ProjectsList.vue?vue&type=template&id=76fd69f8", () => {
    api.rerender('76fd69f8', render)
  })

}


export default __exports__